var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack608({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.7,7.53a1.74,1.74,0,0,1-.85-.68,1.71,1.71,0,0,1-.26-.94A1.9,1.9,0,0,1,6.2,4.45,2.47,2.47,0,0,1,8,3.88a2.47,2.47,0,0,1,1.74.57,1.88,1.88,0,0,1,.62,1.46,1.7,1.7,0,0,1-.28,1,1.78,1.78,0,0,1-.8.65,2.16,2.16,0,0,1,1,.77,2,2,0,0,1,.34,1.17,2.38,2.38,0,0,1-.69,1.77A2.54,2.54,0,0,1,8,11.92a2.83,2.83,0,0,1-1.79-.56,2.21,2.21,0,0,1-.84-1.83A2.25,2.25,0,0,1,5.7,8.36,2.13,2.13,0,0,1,6.7,7.53Zm.18,1.86a1.4,1.4,0,0,0,.31,1,1.06,1.06,0,0,0,.8.35,1,1,0,0,0,.78-.34,1.39,1.39,0,0,0,.3-1,1.25,1.25,0,0,0-.31-.89A1,1,0,0,0,8,8.18a.94.94,0,0,0-.82.38A1.33,1.33,0,0,0,6.88,9.39ZM7,6a1,1,0,0,0,.26.71A.92.92,0,0,0,8,7a1,1,0,0,0,.69-.25A1,1,0,0,0,8.89,6,.88.88,0,0,0,8,5.07.89.89,0,0,0,7,6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack608);
export default __webpack_public_path__ + "static/media/Symbolpack_6_08.f13dda2a60620e8f7ce460da25585a20.svg";
export { ForwardRef as ReactComponent };